import helpers from '@debbie/common/dist/economy/helpers/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import { useWincentPrediction } from '@debbie/cortex/dist/wincent/index.js';
import React from 'react';
import CreditScore from './CreditScore.js';
const CasePrediction = (props) => {
    const { case: singleCase, interactions, documents, caseVouchers, updates, customer, paymentPlans, } = props;
    const tenant = useTenant();
    const valid = tenant != null &&
        !tenant.settings?.aiDisabled &&
        // Check if there is financial data on the case
        caseVouchers.length > 0 &&
        // Check if there is debtors on the case
        customer.users.length > 0;
    const casePredictionLoader = useWincentPrediction(valid, singleCase, {
        interactions,
        documents,
        caseVouchers,
        updates,
        customer,
        paymentPlans,
    });
    const casePrediction = h.hasData(casePredictionLoader) &&
        typeof casePredictionLoader.data?.score === 'number'
        ? casePredictionLoader.data?.score
        : null;
    const balance = -helpers.overview.balance(caseVouchers);
    const deposits = helpers.overview.balance(caseVouchers.filter(helpers.vouchers.isPayment));
    if (tenant == null || tenant.settings?.aiDisabled) {
        return null;
    }
    return casePrediction == null ? null : (React.createElement(CreditScore, { score: casePrediction, paymentRatio: deposits / (balance + deposits) }));
};
export default CasePrediction;
//# sourceMappingURL=CasePrediction.js.map